/**
 * ContactRate.com chevron wordmark.
 * Inline SVG — no external asset dependency.
 * The mark is a stylized "CR" with a signal-strength chevron motif.
 *
 * Wordmark treatment: Archivo italic 800.
 * "ContactRate" in ink, ".com" in brand blue #4285F4 — full size, no shrinking.
 */

import React from 'react';

interface Props {
  className?: string;
  /** Height in pixels — width scales proportionally */
  height?: number;
  /** 'default' = dark ink, 'white' = white (for dark backgrounds) */
  variant?: 'default' | 'white';
}

export function ContactRateLogo({ className, height = 28, variant = 'default' }: Props) {
  const color = variant === 'white' ? '#FFFFFF' : '#0D1729';
  const accentColor = '#2E66E0'; // action blue (chevron bars)
  const dotComColor = '#4285F4'; // brand blue for ".com"

  // "ContactRate.com" is ~5.5× taller-to-wider than the viewBox height of 40
  const width = Math.round(height * 5.5);

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 220 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="ContactRate.com"
    >
      {/* Chevron signal bars (the "mark") */}
      <rect x="0" y="24" width="6" height="10" rx="2" fill={accentColor} opacity="0.4" />
      <rect x="9" y="17" width="6" height="17" rx="2" fill={accentColor} opacity="0.65" />
      <rect x="18" y="10" width="6" height="24" rx="2" fill={accentColor} />
      <rect x="27" y="4" width="6" height="30" rx="2" fill={accentColor} />

      {/* Wordmark: "ContactRate.com" — Archivo italic 800 */}
      <text
        x="40"
        y="28"
        fontFamily="'Archivo', 'Arial Black', sans-serif"
        fontStyle="italic"
        fontWeight="800"
        fontSize="20"
        letterSpacing="-0.4"
      >
        <tspan fill={color}>ContactRate</tspan>
        <tspan fill={dotComColor}>.com</tspan>
      </text>
    </svg>
  );
}
